
export const Magikey = ({ size, color, secondaryColor, isHovered, ...props }: any) => {
  return (
    (
      <svg version="1.0" xmlns="http://www.w3.org/2000/svg"
        width="500.000000pt" height={size} viewBox="0 0 500.000000 500.000000"
        preserveAspectRatio="xMidYMid meet" {...props} >

        <g transform="translate(0.000000,500.000000) scale(0.100000,-0.100000)"
          fill={isHovered ? secondaryColor : color} stroke="none">
          <path d="M2310 4945 c0 -12 -15 -15 -75 -15 -60 0 -75 -3 -75 -15 0 -11 -12
    -15 -50 -15 -27 0 -50 -4 -50 -10 0 -5 -18 -10 -40 -10 -29 0 -40 -4 -40 -15
    0 -10 -10 -15 -30 -15 -20 0 -30 -5 -30 -15 0 -10 -10 -15 -30 -15 -18 0 -33
    -6 -36 -15 -4 -8 -14 -15 -24 -15 -10 0 -23 -7 -30 -15 -7 -8 -21 -15 -31 -15
    -10 0 -21 -4 -24 -10 -3 -5 -15 -10 -26 -10 -10 0 -19 -7 -19 -15 0 -8 -6 -15
    -14 -15 -8 0 -16 -7 -20 -15 -3 -8 -12 -15 -21 -15 -9 0 -26 -11 -39 -25 -13
    -14 -26 -25 -30 -25 -12 0 -186 -177 -186 -189 0 -6 -7 -11 -15 -11 -8 0 -15
    -5 -15 -11 0 -14 -25 -39 -39 -39 -10 0 -16 -21 -12 -43 1 -4 -6 -10 -14 -13
    -8 -4 -15 -12 -15 -20 0 -8 -6 -14 -13 -14 -7 0 -13 -9 -14 -20 -1 -11 -13
    -30 -27 -44 -14 -13 -26 -33 -26 -45 0 -12 -7 -24 -15 -27 -8 -4 -15 -17 -15
    -30 0 -15 -6 -24 -15 -24 -10 0 -15 -10 -15 -30 0 -16 -4 -30 -10 -30 -5 0
    -10 -13 -10 -29 0 -16 -7 -36 -15 -45 -8 -8 -15 -29 -15 -46 0 -18 -6 -33 -15
    -36 -11 -5 -15 -21 -15 -60 0 -41 -4 -54 -15 -54 -12 0 -15 -18 -15 -101 0
    -55 -4 -108 -10 -118 -6 -11 -10 -215 -10 -514 -1 -408 -4 -498 -15 -513 -8
    -11 -15 -27 -15 -37 0 -10 -7 -20 -15 -23 -8 -4 -15 -15 -15 -25 0 -11 -7 -22
    -15 -25 -8 -4 -15 -17 -15 -30 0 -14 -7 -27 -15 -30 -10 -4 -15 -19 -15 -43 0
    -20 -4 -41 -9 -47 -5 -5 -12 -25 -15 -44 -3 -19 -10 -36 -15 -38 -6 -2 -11
    -30 -11 -63 0 -44 -4 -61 -15 -65 -12 -5 -15 -25 -15 -90 0 -77 -2 -84 -20
    -84 -19 0 -20 -7 -20 -140 0 -113 3 -140 14 -140 19 0 26 -32 26 -122 0 -63 3
    -78 15 -78 11 0 15 -13 15 -54 0 -31 5 -56 11 -58 10 -3 23 -50 36 -128 3 -19
    12 -40 19 -48 8 -7 14 -27 14 -43 0 -19 5 -29 15 -29 9 0 15 -9 15 -24 0 -13
    7 -26 15 -30 8 -3 15 -16 15 -30 0 -13 7 -27 16 -30 8 -3 12 -10 9 -16 -3 -5
    -2 -10 4 -10 6 0 13 -11 17 -25 3 -14 10 -25 14 -25 5 0 11 -14 15 -30 4 -17
    13 -30 21 -30 8 0 14 -6 14 -14 0 -8 7 -17 16 -20 9 -4 14 -9 11 -13 -9 -9 25
    -63 40 -63 7 0 13 -5 13 -11 0 -6 31 -42 69 -80 38 -37 66 -71 63 -74 -3 -3 2
    -5 10 -5 9 0 25 -15 37 -33 11 -17 21 -28 21 -24 0 4 13 -6 30 -23 16 -16 34
    -30 40 -30 5 0 10 -7 10 -15 0 -8 7 -15 15 -15 8 0 15 -4 15 -10 0 -5 9 -10
    19 -10 10 0 21 -7 25 -15 3 -8 12 -15 21 -15 8 0 15 -6 15 -14 0 -9 12 -16 28
    -18 15 -2 26 -8 25 -16 -2 -7 7 -12 22 -12 14 0 25 -4 25 -10 0 -5 7 -10 15
    -10 9 0 18 -7 21 -15 4 -8 17 -15 30 -15 15 0 24 -6 24 -15 0 -11 11 -15 41
    -15 24 0 38 -4 34 -10 -4 -6 8 -13 25 -17 18 -3 34 -12 37 -19 3 -9 20 -14 43
    -14 22 0 42 -4 45 -10 3 -5 22 -10 41 -10 22 0 37 -6 40 -15 4 -11 21 -15 55
    -15 35 0 51 -4 55 -15 5 -12 27 -15 109 -15 82 0 104 -3 109 -15 8 -22 226
    -22 226 0 0 12 17 15 94 15 66 0 96 4 98 12 3 7 30 15 64 18 32 3 58 10 57 15
    -1 6 20 11 45 13 26 2 49 7 50 13 2 5 15 9 29 9 13 0 31 7 39 15 9 8 28 15 44
    15 16 0 30 7 34 15 3 8 16 15 30 15 13 0 26 7 30 15 3 8 13 15 21 15 9 0 23 7
    31 15 9 8 24 15 35 15 10 0 19 5 19 10 0 6 7 10 15 10 8 0 15 4 15 10 0 5 11
    12 24 16 14 3 27 12 30 20 3 8 17 14 31 14 16 0 25 6 25 15 0 8 7 15 16 15 8
    0 12 4 9 10 -3 5 0 10 7 10 15 0 54 41 50 53 -1 4 12 7 28 7 17 0 30 5 30 10
    0 13 57 70 70 70 6 0 10 7 10 15 0 8 7 15 15 15 8 0 15 4 15 10 0 13 57 70 70
    70 9 0 15 29 11 53 0 4 4 7 10 7 19 0 77 71 67 83 -2 1 12 17 30 35 17 17 32
    40 32 52 0 11 7 20 15 20 9 0 15 9 15 24 0 13 7 29 15 36 8 7 15 21 15 30 0
    10 3 20 8 22 12 5 42 68 42 88 0 10 7 20 15 24 8 3 15 17 15 31 0 16 6 25 15
    25 11 0 15 11 15 39 0 22 5 43 10 46 6 3 10 26 10 49 0 27 6 48 15 56 10 9 15
    32 15 75 0 47 4 64 15 69 13 5 15 41 15 240 0 199 -2 235 -15 240 -11 4 -15
    22 -15 71 0 45 -4 67 -13 71 -8 3 -14 24 -16 52 -1 26 -6 49 -12 50 -5 2 -9
    19 -9 39 0 19 -7 41 -15 49 -8 9 -15 31 -15 50 0 24 -5 34 -15 34 -9 0 -15 9
    -15 24 0 13 -7 26 -15 30 -8 3 -15 17 -15 31 0 16 -6 25 -16 25 -8 0 -12 5 -9
    10 4 6 0 22 -9 35 -14 21 -16 89 -16 575 0 322 -4 549 -9 546 -14 -9 -21 21
    -21 94 0 51 -4 69 -15 74 -10 3 -15 19 -15 46 0 23 -4 39 -11 38 -6 -2 -12 15
    -15 37 -2 22 -8 41 -14 43 -5 2 -10 21 -10 43 0 28 -4 39 -15 39 -10 0 -15 10
    -15 30 0 20 -5 30 -15 30 -9 0 -15 9 -15 24 0 13 -7 26 -15 30 -8 3 -15 12
    -15 21 0 8 -4 15 -9 15 -5 0 -12 11 -15 25 -4 14 -11 23 -16 20 -6 -4 -10 7
    -10 24 0 21 -5 31 -15 31 -8 0 -15 7 -15 15 0 8 -7 15 -15 15 -8 0 -15 7 -15
    15 0 9 -7 18 -15 21 -8 4 -13 10 -10 14 3 5 -2 15 -10 23 -8 9 -15 20 -15 26
    0 6 -7 11 -15 11 -8 0 -15 7 -15 15 0 8 -5 15 -11 15 -11 0 -69 60 -69 72 0 5
    -7 8 -15 8 -8 0 -15 7 -15 15 0 8 -7 15 -15 15 -8 0 -15 7 -15 15 0 8 -9 15
    -20 15 -12 0 -32 11 -46 25 -14 14 -29 25 -34 25 -6 0 -10 7 -10 15 0 9 -9 15
    -25 15 -14 0 -28 7 -31 15 -4 8 -12 15 -18 15 -22 0 -66 25 -66 38 0 7 -13 12
    -30 12 -20 0 -30 5 -30 15 0 9 -9 15 -25 15 -16 0 -25 6 -25 15 0 11 -11 15
    -40 15 -29 0 -40 4 -40 15 0 11 -11 15 -39 15 -22 0 -43 5 -46 10 -3 6 -19 10
    -35 10 -16 0 -35 7 -44 15 -10 11 -36 15 -86 15 -54 0 -72 4 -76 15 -5 13 -35
    15 -185 15 -152 0 -179 -2 -179 -15z m380 -610 c0 -11 11 -15 38 -15 48 0 83
    -10 76 -21 -3 -5 6 -9 19 -9 14 0 30 -7 37 -15 7 -8 23 -15 35 -15 13 0 25 -5
    27 -11 2 -5 10 -11 18 -13 24 -3 60 -30 60 -43 0 -6 12 -13 28 -15 15 -2 26
    -8 24 -15 -1 -7 3 -13 8 -13 6 0 28 -18 49 -40 21 -22 43 -40 49 -40 7 0 12
    -7 12 -15 0 -8 4 -15 9 -15 5 0 13 -10 17 -22 3 -12 17 -33 30 -47 13 -14 24
    -36 24 -48 0 -14 6 -23 15 -23 9 0 15 -9 15 -24 0 -13 7 -26 15 -30 8 -3 15
    -17 15 -31 0 -14 5 -25 11 -25 5 0 7 -4 4 -10 -3 -5 -1 -10 4 -10 6 0 11 -20
    11 -44 0 -26 5 -46 12 -48 16 -6 24 -419 8 -448 -13 -23 -48 -27 -56 -5 -4 8
    -15 15 -26 15 -11 0 -26 7 -35 16 -9 8 -22 13 -30 10 -7 -3 -16 1 -19 9 -4 9
    -19 15 -35 15 -17 0 -28 5 -26 12 1 7 -15 15 -38 19 -21 3 -41 12 -43 18 -2 6
    -21 11 -43 11 -28 0 -39 4 -39 15 0 11 -11 15 -40 15 -22 0 -40 5 -40 10 0 6
    -28 10 -62 10 -36 0 -75 6 -92 15 -42 22 -470 22 -492 0 -10 -10 -35 -15 -75
    -15 -33 0 -59 -4 -59 -10 0 -5 -25 -10 -55 -10 -42 0 -55 -3 -55 -15 0 -11
    -11 -15 -39 -15 -25 0 -41 -5 -45 -15 -3 -8 -17 -15 -31 -15 -14 0 -28 -7 -31
    -15 -4 -9 -19 -15 -39 -15 -20 0 -35 -6 -39 -15 -3 -8 -17 -15 -31 -15 -14 0
    -25 -4 -25 -10 0 -5 -11 -10 -25 -10 -16 0 -25 -6 -25 -16 0 -11 -8 -14 -27
    -12 l-28 3 -3 198 c-2 150 1 201 10 211 7 7 13 33 13 59 0 29 4 48 12 51 7 3
    13 21 13 41 0 22 6 38 15 41 8 4 15 17 15 30 0 15 6 24 15 24 10 0 15 10 15
    30 0 18 5 30 13 30 7 0 19 16 26 36 7 19 19 38 27 41 8 3 14 11 14 19 0 8 7
    14 15 14 8 0 15 7 15 15 0 8 7 15 15 15 8 0 15 6 15 13 0 8 11 20 25 27 14 7
    25 19 25 27 0 7 7 13 15 13 8 0 15 7 15 15 0 8 6 15 14 15 8 0 16 7 20 15 3 8
    15 15 26 15 11 0 20 4 20 9 0 5 9 13 20 16 11 4 18 11 15 16 -4 5 6 9 20 9 15
    0 33 7 41 15 9 8 28 15 44 15 16 0 30 7 34 15 3 10 19 15 46 15 22 0 39 3 39
    8 -1 4 -1 10 0 14 0 3 93 7 206 8 178 1 205 -1 205 -15z m-50 -1725 c0 -5 21
    -10 48 -10 57 0 94 -9 86 -21 -3 -5 11 -9 30 -9 25 0 36 -4 36 -15 0 -10 10
    -15 29 -15 16 0 36 -7 45 -15 8 -8 17 -15 21 -15 4 0 13 -7 22 -15 8 -8 19
    -13 24 -9 5 3 12 -2 15 -10 3 -9 12 -16 20 -16 8 0 14 -7 14 -15 0 -8 9 -15
    20 -15 11 0 20 -4 20 -9 0 -5 9 -13 21 -16 12 -4 18 -12 15 -21 -3 -8 1 -14 9
    -14 14 0 55 -34 55 -45 0 -3 0 -12 0 -20 0 -8 7 -15 15 -15 8 0 15 -7 15 -15
    0 -8 7 -15 15 -15 9 0 12 -6 9 -15 -4 -9 0 -15 10 -15 10 0 16 -9 16 -24 0
    -13 7 -26 15 -30 8 -3 15 -17 15 -31 0 -14 4 -25 10 -25 5 0 13 -12 16 -27 4
    -16 11 -31 17 -34 5 -4 12 -26 14 -50 3 -24 11 -52 19 -64 18 -28 15 -416 -3
    -423 -7 -2 -13 -19 -13 -37 0 -19 -7 -40 -15 -48 -8 -8 -16 -29 -17 -46 -1
    -17 -8 -33 -15 -35 -7 -3 -13 -12 -13 -21 0 -8 -7 -15 -15 -15 -9 0 -15 -9
    -15 -25 0 -14 -4 -25 -9 -25 -5 0 -12 -14 -16 -30 -4 -17 -13 -30 -21 -30 -9
    0 -12 -5 -9 -10 3 -6 -1 -13 -9 -16 -9 -3 -16 -12 -16 -20 0 -8 -7 -14 -15
    -14 -8 0 -15 -4 -15 -10 0 -5 -7 -10 -16 -10 -8 0 -12 -5 -9 -10 3 -6 -1 -13
    -9 -16 -9 -3 -16 -12 -16 -20 0 -8 -6 -14 -14 -14 -8 0 -16 -7 -20 -15 -3 -8
    -13 -15 -21 -15 -9 0 -14 -4 -11 -9 3 -5 -5 -12 -19 -15 -14 -4 -25 -11 -25
    -16 0 -6 -13 -10 -30 -10 -20 0 -30 -5 -30 -15 0 -8 -7 -15 -15 -15 -9 0 -18
    -7 -21 -15 -4 -9 -19 -15 -39 -15 -20 0 -35 -6 -39 -15 -3 -9 -18 -15 -40 -15
    -19 0 -38 -4 -41 -10 -4 -6 -202 -10 -561 -10 l-554 0 0 504 c0 368 3 505 11
    508 7 2 13 28 14 58 1 30 7 56 14 58 6 2 11 18 11 37 0 18 7 38 15 45 8 7 15
    23 15 36 0 15 6 24 15 24 9 0 15 9 15 25 0 14 6 28 14 31 7 3 22 22 32 42 22
    42 96 122 114 122 7 0 10 7 6 15 -3 8 -1 15 4 15 13 0 50 37 50 50 0 6 11 10
    25 10 25 0 68 33 58 44 -4 3 8 6 25 6 22 0 32 5 32 15 0 10 10 15 31 15 16 0
    28 4 25 9 -7 11 17 21 54 21 16 0 30 7 34 15 4 11 20 15 56 15 27 0 50 5 50
    10 0 6 58 10 155 10 97 0 155 -4 155 -10z"/>
        </g>
      </svg>
    )
  )
}

